module.exports = __webpack_public_path__ + "static/img/moling.5f8da59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moling.png
// module id = 7f+l
// module chunks = 1